
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-truck)"}},[_c('path',{attrs:{"d":"M20.727 7.636h-3.273V3.273H2.182A2.181 2.181 0 000 5.455v12h2.182a3.275 3.275 0 003.273 3.272 3.275 3.275 0 003.272-3.272h6.546a3.275 3.275 0 003.273 3.272 3.275 3.275 0 003.272-3.272H24V12l-3.273-4.364zM5.455 19.091c-.906 0-1.637-.731-1.637-1.637 0-.905.731-1.636 1.637-1.636.905 0 1.636.731 1.636 1.636 0 .906-.731 1.637-1.636 1.637zm13.09 0c-.905 0-1.636-.731-1.636-1.637 0-.905.731-1.636 1.637-1.636.905 0 1.636.731 1.636 1.636 0 .906-.731 1.637-1.636 1.637zM17.456 12V9.273h2.727L22.325 12h-4.87z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-truck"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    